<template>
  <nav id="sidebar">

    <div class="logo" v-show="!sidebarCollapsed">
      <img class="sidebar__logo" src="@/assets/images/control-center.png" alt="Thrive Control Center">
    </div>

    <div class="text-center my-1" v-show="!sidebarCollapsed">{{ displayVersion }}</div>

    <hr class="divider light"/>

    <navigation-group v-for="route in visibleRoutes" :key="route.id" :route="route" @groupOpened="groupOpened"
                      @registerGroup="registerGroup"></navigation-group>

  </nav>
</template>

<script>
import NavigationGroup from './NavigationGroup'
import navigationService from './navigation-service'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import notInPosYetMixin from '@/common/mixins/not-in-pos-yet-mixin'
import { mapState, mapActions } from 'vuex'
import { isTOLEnabled } from '@/common/utils/tol-utils'

export default {
  components: { NavigationGroup },
  name: 'navigation-left',
  mixins: [userInfoMixin, notInPosYetMixin],
  data () {
    return {
      navigationGroups: [],
      thriveOnlineAuth: false
    }
  },
  computed: {
    ...mapState('login', ['activeLocation', 'softwareVersion']),
    displayVersion () {
      return this.softwareVersion
    },
    sidebarCollapsed () { return this.$store.state.main.sidebarCollapsed },
    // Take away MANAGE_MENUS if user is at location level unless they have OVERRIDE_MENUS.
    filteredFeatures () {
      return this.enabledFeatures
        .filter(f => this.filterOverrideMenus(f))
    },
    routes () { return navigationService.getNavigationLeft(this.filteredFeatures) },
    visibleRoutes () { return this.routes.filter(r => !this.hideRoutes[r.id] && (this.kioskActive || r.id !== 'kiosk')) },
    kioskActive () { return !this.activeLocation || this.activeLocation.kioskActive }
  },
  watch: {
    activeLocation: {
      async handler () {
        this.hideNotInPosYet()

        if (!this.activeLocation || isTOLEnabled(this.activeLocation)) {
          this.showOnline()
        } else {
          this.hideOnline()
        }
      },
      immediate: true
    }
  },
  provide () {
    return {
      addOpenListener: this.addOpenListener
    }
  },
  methods: {
    ...mapActions('navigation', ['showNavItem', 'hideNavItem']),
    filterOverrideMenus (feature) {
      return feature !== 'MANAGE_MENUS' ||
        !this.activeLocation ||
        this.enabledFeatures.includes('OVERRIDE_MENUS')
    },
    groupOpened (id) {
      this.navigationGroups.forEach(next => {
        if (next.route.id !== id) {
          next.close()
        }
      })
    },
    registerGroup (group) {
      this.navigationGroups.push(group)
    },
    hideNotInPosYet () {
      Object.keys(this.hideRoutes).forEach((key) => {
        if (this.hideRoutes[key]) {
          this.hideNavItem(key)
        } else {
          this.showNavItem(key)
        }
      })
    },
    showOnline () {
      this.showNavItem('onlineDesign')
      this.showNavItem('onlineCategories')
    },
    hideOnline () {
      this.hideNavItem('onlineDesign')
      this.hideNavItem('onlineCategories')
    }
  }
}
</script>

<style lang="scss" scoped>
  #sidebar {
    color: white;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .logo {
    text-align: center;

    img {
      width: 180px;
      margin: 20px auto 10px;
    }
  }
</style>
